import React from 'react';
import { Link } from 'react-router-dom'
import styled from 'styled-components';

const subStyles = `
    color: white;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: 'white !important';
    background: #0368e0;
    background: linear-gradient(to top left, #0368e0, #328efc);
    padding: 4px 12px;
    box-shadow: 1px 1px 2px black;
    font-size: 12px;
    font-weight: 600;
    border: none;
    margin: 5px;
    svg {
    margin-right: 5px;
    }
    &:hover {
    color: white;
    text-decoration: none;
    }
`
//React router doesn't support anchor links
const SubA = styled.a`${subStyles}`

const SubLink = styled(Link)`${subStyles}`

export default function SubstituteLink(props) {
    const { to, href, className } = props;

    return (
        <>
            {
                to && (
                    <SubLink {...{ to }} >
                        Substitute Available
                    </SubLink>
                )
            }
            {
                href && (
                    <SubA {...{ href }} className={className}>
                        Substitute Available
                    </SubA>
                )
            }
        </>
    )
}